<template>
  <div class="post-container">
    <b-modal
      id="skinModal"
      ref="skinModal"
      header-bg-variant="dark"
      header-text-variant="light"
      :hide-footer="true"
      size="lg"
      :title="modalTitle"
      body-bg-variant="dark"
      @hide="onClose"
    >
      <b-container fluid>
        <div class="">
          <div class="row">
            <div class="col-4">
              <img :src="currentSkin.image" alt="Skin Image" class="img-fluid">
            </div>
            <div class="col-8">
              <div class="weapon">
                <h2 v-if="currentSkin.rarity" :style="{ color: currentSkin.rarity.color }">{{ currentSkin.name }}</h2>
                <h2 v-else>{{ currentSkin.name }}</h2>

                <div class="rarity" :style="{ color: currentSkin.rarity.color }">
                  {{ currentSkin.rarity.name }}
                </div>

              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <b-form @submit.prevent="onSubmit">
                <!-- ckeck if can be on both and can be selected -->
                <div class="form-group" v-if="shouldShowTeamSelector">
                  <label for="team">Team</label>
                  <div class="btn-group w-100" role="group">
                    <button type="button" 
                            :class="['btn', form.team === 0 ? 'btn-primary' : 'btn-secondary']"
                            @click="form.team = 0">
                      Both Teams
                    </button>
                    <button type="button"
                            :class="['btn', form.team === 2 ? 'btn-primary' : 'btn-secondary']" 
                            @click="form.team = 2">
                      T
                    </button>
                    <button type="button"
                            :class="['btn', form.team === 3 ? 'btn-primary' : 'btn-secondary']"
                            @click="form.team = 3">
                      CT
                    </button>
                  </div>
                </div>

                <div class="form-group" v-if="false">
                  <label for="wear">Wear</label>
                  <div class="btn-group w-100" role="group">
                    <button v-for="wear in currentSkin.wears" 
                            :key="wear.id"
                            type="button"
                            :class="['btn', form.wear === wear.id ? 'btn-primary' : 'btn-secondary']"
                            @click="onWearChange(wear.id)">
                      {{ wear.name }}
                    </button>
                  </div>
                </div>

                <div class="form-group">
                  <label for="float">Float ({{ currentSkin.min_float }} - {{ currentSkin.max_float }})</label>
                  <input type="number" class="form-control" v-model="form.float" :min="currentSkin.min_float" :max="currentSkin.max_float" step="0.01" />
                  <input type="range" class="form-control" v-model="form.float" :min="currentSkin.min_float" :max="currentSkin.max_float" step="0.01" />
                </div>

                <div class="form-group">
                  <label for="weapon_seed">Pattern/Seed</label>
                  <input type="number" class="form-control" v-model="form.weapon_seed" :min="0" :max="1000" />
                  <input type="range" class="form-control" v-model="form.weapon_seed" :min="0" :max="1000" />
                </div>

                <div class="form-group" v-if="false && currentSkin.stattrak">
                  <label for="stattrak">Stattrak</label>
                  <input type="checkbox" class="form-control" v-model="form.stattrak" />
                </div>

                <div class="stattrak" v-if="false && currentSkin.stattrak">
                  tem stattrak
                </div>

                <div class="souvenir" v-if="false && currentSkin.souvenir">
                  tem souvenir
                </div>

                <div class="form-group" v-if="isInLoadout">
                  <button class="btn btn-danger btn-block btn-lg" @click.stop.prevent="onRemoveFromLoadout">Remove from Loadout</button>
                </div>
                <button type="submit" class="btn btn-success btn-block btn-lg">Submit</button>
              </b-form>
              
            </div>
          </div>
          <!-- {{ currentSkin.id }} -->
          <!-- {{ currentSkin.weapon.name }} -->
          <!-- {{ currentSkin.weapon.id }} -->
          <!-- {{ currentSkin.category.name }} -->
          <!-- {{ currentSkin.category.id }} -->
          <!-- {{ currentSkin.pattern.name }} -->
          <!-- {{ currentSkin.pattern.id }} -->
          <!-- {{ currentSkin.souvenir }} souvenir -->
          <!-- {{ currentSkin.paint_index }} paint_index -->

          
          
        </div>
      </b-container>
    </b-modal>
  </div>
</template>

<script>
// TODO: CHECK IF THIS IS RIGHT
import skinsService from '@/services/skins.service.js'
const teamMapping = {
  'counter-terrorists': 3,
  'terrorists': 2,
  'both': 0
}



export default {
  name: "skinModal",
  props: {
    showClose: Boolean,
    currentSkin: Object,
    loadout: Object,
    currentWeapon: String
  },
  computed: {
    shouldShowTeamSelector () {
      try {
        return teamMapping[this.currentSkin.team.id] == 0
      } catch (e) {
        return false;
      }
    },
    isInLoadout () {
      try {
        return this.loadout.skins.find(s => s.weapon_paint_id.toString() === this.currentSkin.paint_index.toString())
      } catch (e) {
        return false;
      }
    }
  },
  data() {
    return {
      modalTitle: "Skin",
      form: {
        wear: 'Factory New',
        float: 0.06,
        paint_index: 0,
        stattrak: false,
        team: 0,
        weapon_seed: 0,
      }
    };
  },
  methods: {
    async initialize() {
      this.$refs.skinModal.show();
      this.modalTitle = this.currentSkin.name;
      this.form.paint_index = this.currentSkin.paint_index;
      this.form.float = this.currentSkin.min_float;

      if (!this.shouldShowTeamSelector) {
        this.form.team = teamMapping[this.currentSkin.team.id]
      }
      
    },
    onClose() {
      console.log('onClose')
      this.$emit('onClose')
    },
    onWearChange(wearId) {
      this.form.wear = wearId;

      const proportion = this.currentSkin.min_float + (this.currentSkin.max_float - this.currentSkin.min_float) * (wearId / 4);

      this.form.float = proportion;
    },
    async onSubmit () {
      // console.log('onSubmit')
      // console.log(this.form)

      const skinService = new skinsService(this.$http, this.currentUser.steamid)
      await skinService.addWeaponSkinPaint(this.currentSkin.weapon.id, this.currentSkin.paint_index, this.form.team, this.form.float, this.currentSkin.weapon.weapon_id, this.form.weapon_seed)

      this.$emit('onRemoveFromLoadout')
    },
    async onRemoveFromLoadout () {
      const skinService = new skinsService(this.$http, this.currentUser.steamid)
      await skinService.deleteSkinPaint(this.currentSkin.weapon.id, this.currentSkin.paint_index)
      if (skinService.isKnife(this.currentSkin.weapon.weapon_id)) {
        await skinService.deleteKnife(this.currentWeapon, this.form.team)
      }
      this.$emit('onRemoveFromLoadout')
    }
  },
  mounted() {
    this.initialize();
  }
};
</script>

<style lang="sass" scoped>
</style>
